interface ToggleIrisProps {
  ativo: boolean;
  onChange?: (valor: boolean) => void;
  disabled?: boolean;
  'aria-label'?: string;
}

/** Switch Íris 44×24 (track accent quando ligado). */
export default function ToggleIris({ ativo, onChange, disabled = false, 'aria-label': ariaLabel }: ToggleIrisProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={ativo}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange?.(!ativo)}
      className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${
        ativo ? 'bg-accent' : 'bg-surface-2 border border-line'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
          ativo ? 'translate-x-6' : 'translate-x-1'
        }`}
      />
    </button>
  );
}
